module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/flashlight-5204a44ed0965c80018883d8fe915b6d.svg";